module.exports = __webpack_public_path__ + "static/img/icon-apply-checking.0de9a305.png";